// extracted by css-extract-rspack-plugin
export default {"cls1":"SingularMentionCitationModal-cls1_b6I","cls2":"SingularMentionCitationModal-cls2_u7C SingularMentionCitationModal-cls1_b6I"};